"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_mail_search_store_1 = require("owa-mail-search-store");
var owa_mail_search_actions_1 = require("owa-mail-search-actions");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Dialog_1 = require("office-ui-fabric-react/lib/Dialog");
var React = require("react");
var Checkbox_1 = require("office-ui-fabric-react/lib/Checkbox");
var mobx_react_1 = require("mobx-react");
var Link_1 = require("office-ui-fabric-react/lib/components/Link");
var sendSearchFeedback_1 = require("../utils/sendSearchFeedback");
var TextField_1 = require("office-ui-fabric-react/lib/TextField");
var styles = require('./SearchInContextFeedbackDialog.scss');
var classNames = require('classnames/bind');
// this feature can NEVER ship beyond MSIT since it contains PII,
// so we store our strings locally (so that they don't get localized)
var unlocalizedStrings = {
    dialogTitle: 'What issues did you encounter?',
    feedbackCommentsPlaceholder: 'Tell us what happened or how we can improve',
    primaryButtonText: 'Provide feedback',
    feedbackLauncherText: 'Search issues?',
    feedbackLauncherLink: 'Submit feedback',
};
var SearchInContextFeedbackDialog = /** @class */ (function (_super) {
    tslib_1.__extends(SearchInContextFeedbackDialog, _super);
    function SearchInContextFeedbackDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCategoryCheckboxes = function () {
            return owa_mail_search_store_1.searchStore.searchInContextFeedbackViewState.feedbackCategories.map(function (category, i) { return (React.createElement(Checkbox_1.Checkbox, { key: i, checked: category.checked, label: category.label, className: styles.feedbackCategoryCheckbox, onChange: function (ev, isChecked) {
                    return owa_mail_search_actions_1.lazyUpdateSearchInContextFeedbackCategoryCheckbox(i, isChecked);
                } })); });
        };
        _this.onProvideFeedback = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                sendSearchFeedback_1.default();
                owa_mail_search_actions_1.lazySetIsSearchInContextFeedbackDialogShown(false);
                return [2 /*return*/];
            });
        }); };
        _this.onInput = function (newValue) {
            owa_mail_search_actions_1.lazyUpdateSearchInContextFeedbackDialogComments(newValue);
        };
        return _this;
    }
    SearchInContextFeedbackDialog.prototype.render = function () {
        return (React.createElement("div", { className: classNames(this.props.cssClass, styles.linkContainer) },
            React.createElement("span", { className: styles.feedbackLauncher },
                unlocalizedStrings.feedbackLauncherText,
                "\u00A0",
                React.createElement(Link_1.Link, { onClick: function () {
                        owa_mail_search_actions_1.lazyResetSearchInContextFeedbackViewState();
                        owa_mail_search_actions_1.lazySetIsSearchInContextFeedbackDialogShown(true);
                    } }, unlocalizedStrings.feedbackLauncherLink)),
            owa_mail_search_store_1.searchStore.searchInContextFeedbackViewState.isFeedbackDialogShown && (React.createElement(Dialog_1.Dialog, { hidden: false, onDismiss: function () { return owa_mail_search_actions_1.lazySetIsSearchInContextFeedbackDialogShown(false); }, title: unlocalizedStrings.dialogTitle, containerClassName: styles.dialogContainer, contentClassName: styles.content },
                this.renderCategoryCheckboxes(),
                React.createElement(TextField_1.TextField, { multiline: true, value: owa_mail_search_store_1.searchStore.searchInContextFeedbackViewState.feedbackComments, onChanged: this.onInput, className: styles.textAreaContainer, inputClassName: styles.textArea, placeholder: unlocalizedStrings.feedbackCommentsPlaceholder }),
                React.createElement(Dialog_1.DialogFooter, null,
                    React.createElement(Button_1.PrimaryButton, { onClick: this.onProvideFeedback }, unlocalizedStrings.primaryButtonText))))));
    };
    SearchInContextFeedbackDialog = tslib_1.__decorate([
        mobx_react_1.observer
    ], SearchInContextFeedbackDialog);
    return SearchInContextFeedbackDialog;
}(React.Component));
exports.default = SearchInContextFeedbackDialog;
//# sourceMappingURL=SearchInContextFeedbackDialog.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-search-view/lib/components/SearchInContextFeedbackDialog.js
// module id = 4841
// module chunks = 37